import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import type {
  PartnerReferralCode,
  CreatePartnerReferralCodePayload,
} from '../types/partnerReferralCode';
import { partnerReferralCodeQueryKeys } from './usePartnerReferralCodes';

export function useCreatePartnerReferralCode(
  options?: UseMutationOptions<
    PartnerReferralCode,
    Error,
    CreatePartnerReferralCodePayload
  >,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['partnerReferralCode', 'create'],
    mutationFn: async (payload: CreatePartnerReferralCodePayload) => {
      return service.createPartnerReferralCode(payload);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({
        queryKey: partnerReferralCodeQueryKeys.all,
      });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
